import { Typography, type TypographyAsProps } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import React from 'react'
import styles from './SectionTitle.module.css'

type SectionTitleProps = TypographyAsProps<'h2'>

export default function SectionTitle({ children, className, ...rest }: React.PropsWithChildren<SectionTitleProps>) {
  return (
    <Typography
      variant="display-g-regular"
      as="h2"
      className={cn(styles.typography, className)}
      {...rest}
    >
      {children}
    </Typography>
  )
}
